module.exports = __webpack_public_path__ + "static/img/labelswap_logo.720c17d9.png";